import React from 'react'

import { Header } from '../../../lib/header'
import LanguageSelect from '../../../ui/LanguageSelect'
import { WidgetLayout } from '../../../lib/widget-layout'
import { useUserUpdateUserSettingsMutation } from '../../../common/redux/api/web-api'
import { notifyError } from '../../../common/features/notificationsManager/Notify'
import useText from '../../../common/hooks/useText'

export type UserProfileLanguageSelectProps = {
    userId: string
}
export enum SettingName {
    LANGUAGE = 'Language',
    GREEN_CHARGING_INFORMED = 'GreenChargingInformed',
}

export function UserProfileLanguageSelect({ userId }: UserProfileLanguageSelectProps): React.ReactElement {
    const text = useText()
    const [updateUserSettingRequest] = useUserUpdateUserSettingsMutation()

    const changeUserSettingRequest = async (language: string) => {
        try {
            await updateUserSettingRequest({
                userId: userId,

                body: [
                    {
                        name: SettingName.LANGUAGE,
                        value: language,
                    },
                ],
            })
        } catch (error) {
            notifyError(text('lblFailedLanguageUpdate'))
        }
    }

    const onChangeLanguage = (language: string) => {
        changeUserSettingRequest(language)
    }

    return (
        <WidgetLayout
            title={<Header code="lblLanguagePreference" data-testid="languageHeader" />}
            data-testid="languageSelect"
        >
            <LanguageSelect onChange={onChangeLanguage} styles={{}} asWidget={true} />
        </WidgetLayout>
    )
}
